import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { isCloud } from '@skbkontur/staff-common';
const trackEvent = (category, action, label, customVariables) => {
    if (!window.employees_formQueue) {
        window.employees_formQueue = [];
    }
    window.employees_formQueue.push(['trackEvent', category, action, label, JSON.stringify(customVariables)]);
};
const getTrackAction = (employerId, clientName, metricsOptions) => (category, action, options) => trackEvent(category, action, undefined, {
    productId: clientName,
    context: metricsOptions,
    employerId,
    ...options,
});
const StaffServiceMetricsContext = React.createContext(() => null);
export const useStaffServiceMetrics = () => React.useContext(StaffServiceMetricsContext);
export const MetricsProvider = ({ employerId, clientName, metricsOptions, children, }) => {
    const trackAction = getTrackAction(employerId, clientName, metricsOptions);
    useEffect(() => {
        if (window.location.hostname.includes('localhost')) {
            window.employees_formQueue.push(['enableDevMode']);
        }
        const script = document.createElement('script');
        script.src = `https://metrika.${isCloud() ? 'test' : ''}kontur.ru/tracker/employees_form.js`;
        script.async = true;
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, []);
    return _jsx(StaffServiceMetricsContext.Provider, { value: trackAction, children: children });
};
